module.exports = __webpack_public_path__ + "img/interface-01.36a6961b.jpg";